export const rateItem = [
  {
    key: 'BMI',
    label: 'BMI_range',
    color: 'COLOR_RATE',
    comment: 'COMMENT_LEVEL',
  },
  {
    key: 'BMR',
    label: 'BMR_range',
    color: 'COLOR_RATE',
    comment: 'COMMENT_LEVEL',
  },
  {
    key: 'body_fat_rate',
    label: 'body_fat_rate_range',
    color: 'COLOR_RATE',
    comment: 'COMMENT_LEVEL',
  },
  {
    key: 'body_water_rate',
    label: 'body_water_rate_range',
    color: 'COLOR_RATE_MUS',
    comment: 'COMMENT_LEVEL_MUS',
  },
  {
    key: 'bone_mass',
    label: 'bone_mass_range',
    color: 'COLOR_RATE',
    comment: 'COMMENT_LEVEL',
  },
  {
    key: 'metabolic_age',
    label: 'metabolic_age_range',
    color: 'COLOR_RATE',
    comment: 'COMMENT_LEVEL',
  },
  {
    key: 'muscle_mass',
    label: 'muscle_mass_range',
    color: 'COLOR_RATE_MUS',
    comment: 'COMMENT_LEVEL_MUS',
  },
  {
    key: 'muscle_rate',
    label: 'muscle_rate_range',
    color: 'COLOR_RATE',
    comment: 'COMMENT_LEVEL',
  },
  {
    key: 'protein',
    label: 'protein_range',
    color: 'COLOR_RATE_MUS',
    comment: 'COMMENT_LEVEL_MUS',
  },
  {
    key: 'subcutaneous_fat',
    label: 'subcutaneous_fat_range',
    color: 'COLOR_RATE',
    comment: 'COMMENT_LEVEL',
  },
  {
    key: 'visceral_fat',
    label: 'visceral_fat_range',
    color: 'COLOR_RATE_FAT',
    comment: 'COMMENT_LEVEL_FAT',
  },
  {
    key: 'weight',
    label: 'weight_range',
    color: 'COLOR_RATE',
    comment: 'COMMENT_LEVEL',
  },
]

export const COLOR_RATE = {
  0: 'rate-none-color p-1',
  1: 'rate-insufficient-color p-1',
  2: 'rate-low-color p-1',
  3: 'rate-standard-color p-1',
  4: 'rate-hight-color p-1',
  5: 'rate-excess-color p-1',
}

export const COLOR_RATE_FAT = {
  0: 'rate-none-color p-1',
  1: 'rate-insufficient-color p-1',
  2: 'rate-standard-color p-1',
  3: 'rate-hight-color p-1',
  4: 'rate-excess-color p-1',
}

export const COLOR_RATE_MUS = {
  0: 'rate-none-color p-1',
  1: 'rate-insufficient-color p-1',
  2: 'rate-low-color p-1',
  3: 'rate-standard-color p-1',
  4: 'rate-sufficient-color p-1',
}
